module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Wood_MockedUp.e5fdcc4d.jpg";